import React from "react";

export default function RagConceptBanner({ concept, onConceptSearch }) {
  if (!concept || !concept.name) return null;
  const lead =
    concept.confidence === "medium"
      ? "Showing results related to"
      : "Showing results for";
  const related = Array.isArray(concept.related) ? concept.related : [];
  return (
    <div className="rounded-lg bg-primaryBlue bg-opacity-10 border border-primaryBlue p-4 mb-6">
      <div className="text-primaryDark">
        <span className="opacity-70">{lead} </span>
        <span className="font-extrabold">▸ {concept.name}</span>
      </div>
      {concept.definition && (
        <div className="text-sm text-primaryDark opacity-80 mt-1">
          {concept.definition}
        </div>
      )}
      {related.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {related.map((r) => (
            <button
              key={r.slug ?? r.name}
              type="button"
              onClick={() => onConceptSearch && onConceptSearch(r.name)}
              className="rounded-full bg-whiteGrey border border-primaryBlue text-primaryBlue text-sm px-3 py-1 hover:bg-primaryBlue hover:text-whiteGrey transition"
            >
              {r.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
